import { render } from "./KycPending.vue?vue&type=template&id=71db2bd8&ts=true"
import script from "./KycPending.vue?vue&type=script&lang=ts"
export * from "./KycPending.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__